import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, throwError } from 'rxjs';
import { URLS } from '../constants/URLS';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InternationalauthService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  headers_post: HttpHeaders;  
  error = new Subject<string>()
  constructor(
    private http: HttpClient
  ) { }

  internationalSignIn(requestBody){
    return this.http.post<any>(URLS.internationalAuthSignIn, requestBody, this.httpOptions)
    .pipe(
      map(responseData => 
        {
          console.log(responseData);
          if(responseData.status === 'SUCCESS' && responseData.data.userData && responseData.data.idToken){
            localStorage.setItem('token',responseData.data.idToken);
            localStorage.setItem('refreshToken',responseData.data.refreshToken);
            localStorage.setItem('userId',responseData.data.userData.localUserId);
            localStorage.setItem('screenName',responseData.data.userData.screenName);
            localStorage.setItem('userName',responseData.data.userData.userName);
            localStorage.setItem('description',responseData.data.userData.description);
            localStorage.setItem('profileImage',responseData.data.userData.profileImage);
            localStorage.setItem('recoveryEmail',responseData.data.userData.recoveryEmail);
            return responseData.data;
          }else{
            return undefined
          }
        }), catchError(errorRes => {
          return throwError(errorRes);
        }))
  }

  internationalSignUp(requestBody){
    return this.http.post<any>(URLS.internationalAuthRegister, requestBody, this.httpOptions)
    .pipe(
      map(responseData => 
        {
          console.log(responseData);
          if(responseData.status === 'SUCCESS' && responseData.data.userData && responseData.data.idToken){
            localStorage.setItem('token',responseData.data.idToken);
            localStorage.setItem('refreshToken',responseData.data.refreshToken);
            localStorage.setItem('userId',responseData.data.userData.localUserId);
            localStorage.setItem('screenName',responseData.data.userData.screenName);
            localStorage.setItem('userName',responseData.data.userData.userName);
            localStorage.setItem('description',responseData.data.userData.description);
            localStorage.setItem('profileImage',responseData.data.userData.profileImage);
            localStorage.setItem('recoveryEmail',responseData.data.userData.recoveryEmail);
            return responseData.data;
          }else{
            return undefined
          }
        }), catchError(errorRes => {
          return throwError(errorRes);
        }))
  }
}
